"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuoteRepository = void 0;
const QuoteModel_1 = require("../Model/QuoteModel");
class QuoteRepository {
    constructor(client) {
        this.clientWithRetry = client.clientWithRetry;
        this.clientWithoutRetry = client.clientWithoutRetry;
    }
    getById(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield this.clientWithRetry.get(`/quote/${id}`);
            return QuoteModel_1.QuoteModel.fromJSON(data, { groups: ['READ'] });
        });
    }
    validateQuote(id, quote) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield this.clientWithRetry.patch(`/quote/${id}/validate`, quote);
            return QuoteModel_1.QuoteModel.fromJSON(data, { groups: ['UPDATE'] });
        });
    }
    updateQuoteBillingInfos(id, quote) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield this.clientWithRetry.patch(`/quote/${id}/billing`, quote);
            return QuoteModel_1.QuoteModel.fromJSON(data, { groups: ['UPDATE'] });
        });
    }
    updateQuoteShopBillingInfos(id, quote) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield this.clientWithoutRetry.patch(`/quote/${id}/shop/billing`, quote);
            return QuoteModel_1.QuoteModel.fromJSON(data, { groups: ['UPDATE'] });
        });
    }
}
exports.QuoteRepository = QuoteRepository;
//# sourceMappingURL=QuoteRepository.js.map